export const LEGAL_SLUGS = [
  "terms",
  "privacy",
  "booking_policy",
  "user_agreement",
  "landowner_agreement",
  "hunting_waiver",
  "ice_fishing_waiver",
] as const;

export type LegalSlug = (typeof LEGAL_SLUGS)[number];

export const slugTitleMap: Record<LegalSlug, string> = {
  terms: "Terms & Conditions",
  privacy: "Privacy Policy",
  booking_policy: "Booking Policy",
  user_agreement: "User Agreement",
  landowner_agreement: "Landowner Agreement",
  hunting_waiver: "Hunting Waiver",
  ice_fishing_waiver: "Ice-Fishing Waiver",
};

export const isLegalSlug = (value: string): value is LegalSlug =>
  (LEGAL_SLUGS as readonly string[]).includes(value);
